export default __webpack_public_path__ + "static/media/woman@2x.6b26b191.jpg";